import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useEffect, useState, } from 'react';
// Create the context with undefined as default
export const WidgetContext = createContext(undefined);
// Create the context provider component
export const WidgetContextProvider = ({ children, initialContext = {}, contextUpdateKey = '__WIDGET_CONTEXT_UPDATE', onLifecycleEvent, onRegisterLifecycleHandler, }) => {
    const [widgetContext, setWidgetContext] = useState({
        context: initialContext,
        updateTimestamp: Date.now(),
    });
    // Handle context updates - wrapped in useCallback to prevent useEffect dependency issues
    const updateContext = useCallback((newContext) => {
        setWidgetContext({
            context: newContext,
            updateTimestamp: Date.now(),
        });
    }, []);
    // Connect to window global callback
    useEffect(() => {
        // Type assertion to make TypeScript happy
        const win = window;
        // Expose updateContext to the widget shell
        win[contextUpdateKey] = updateContext;
        // Clean up on unmount
        return () => {
            win[contextUpdateKey] = undefined;
        };
    }, [contextUpdateKey, updateContext]);
    // Define what we expose to consumers
    const contextValue = {
        widgetContext: widgetContext,
        updateContext: updateContext,
        onLifecycleEvent,
        registerLifecycleHandler: onRegisterLifecycleHandler,
    };
    return (_jsx(WidgetContext.Provider, { value: contextValue, children: children }));
};
//# sourceMappingURL=WidgetContext.js.map